module.exports = __webpack_public_path__ + "img/icon-1.2150b96b.jpg";